import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckoutSteps } from '../../MobileStepbar/types';
import { overridedIcons } from '../../Icons';
import { CartContext } from '../Cart';
import ServiceSummaryCard from '../../ServiceSummary';
import { ServiceSummary } from '../../features/service-summary';
const Seats = ({ travellers, onServiceDelete, renderService }) => {
    var _a;
    const cartContext = React.useContext(CartContext);
    const { t } = useTranslation('Cart');
    const seats = React.useMemo(() => {
        return travellers.filter(traveller => { var _a; return !!((_a = traveller.services.seats) === null || _a === void 0 ? void 0 : _a.length); });
    }, travellers);
    const group = {
        header: t('Seats'),
        icon: overridedIcons['SeatSelection'],
        totalPrice: (_a = cartContext.totalPrices) === null || _a === void 0 ? void 0 : _a.seats
    };
    if (!seats.length && !renderService) {
        return null;
    }
    return (React.createElement(ServiceSummary, { serviceType: "Seat", onDelete: onServiceDelete }, content => {
        var _a;
        return (_a = renderService === null || renderService === void 0 ? void 0 : renderService(CheckoutSteps.Seats, group, content)) !== null && _a !== void 0 ? _a : (React.createElement(ServiceSummaryCard, { group: group }, content));
    }));
};
export default Seats;
